const AppRoutes = {
  index: "/",
  auth: "/auth",
  login: "login",
  dashboard: "/dashboard",
  channels:"channels",
  channel:"channel",
  tasks: "tasks",
  users: "accounts",
  user: "account",
  payments: "payments",
  analytics: "analytics",
  notifications: "notifications",
  notification:"notification",
  payment: "clear",
  languages: "languages",
  language: "language",
  subjects: "subjects",
  subject: "subject",
  subtitles:"subtitles",
  games: "games",
  game: "game",
  appSettings: "app-settings",
  music: "music",
  backgroundMusics: "background-music",
  challenges: "challenges",
  challenge: "challenge",
  localization: "localization",
  packages: "packages",
  partners: "partners",
  partner: "partner",
  trials: "trials",
  package: "package",
  contents: "contents",
  content: "content",
  types: "types",
  type: "content-type",
  sections: "sections",
  section: "content-section",
  shows:"shows",
  show: "show",
  password:"reset-password",
  featured:"featured-content",
  cicd:"ci-cd",
  plays:"play-now"
};

export default AppRoutes;